import { useDispatch } from "react-redux";
import { findChannel } from "../../slices/commands/liveCommandsSlice";

const CommandsLoader = () => {
    const dispatch = useDispatch();
    window.findChannel = (channel) => {
        dispatch(findChannel(channel));
    };
    return null;
}

export default CommandsLoader;